var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendRequest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5312 13.355V15.5112H17.375V16.9487H19.5312V19.105H20.9688V16.9487H23.125V15.5112H20.9688V13.355H19.5312Z",
    fill: "#78909C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.79159 14.3636L2.45288 12.9022C2.28304 12.8273 2.1383 12.7051 2.03587 12.5503C1.93344 12.3955 1.87764 12.2145 1.87509 12.0289C1.87254 11.8433 1.92336 11.6608 2.02151 11.5032C2.11965 11.3457 2.26098 11.2196 2.4287 11.14L18.8707 3.40259C19.0232 3.33138 19.1916 3.30109 19.3593 3.3147C19.527 3.32831 19.6883 3.38535 19.8272 3.48021C19.9662 3.57508 20.0781 3.70449 20.1519 3.85571C20.2257 4.00694 20.2588 4.17477 20.248 4.34269L19.8408 10.4516C16.9248 10.6612 14.6243 13.0932 14.6243 16.0626C14.6243 16.8961 14.8056 17.6873 15.1308 18.3989L9.61001 15.885L15.4131 9.11475L5.79159 14.3636ZM12.2949 19.4481L7.67565 21.6881V17.2932L12.2949 19.4481Z",
    fill: "#78909C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendRequest);
export default __webpack_public_path__ + "static/media/send_request.1d5b5172.svg";
export { ForwardRef as ReactComponent };